import React from 'react';
import { Box, Tooltip } from '@mui/material';

import { humanCase } from '@paragon/utilities';

import { StatusPercentage } from '../../selectors/getStatusPercentages';
import { statusColors } from '../statusColors';

interface StatusesAsColorBarProps {
  readonly statusPercentages: readonly StatusPercentage[];
  readonly statusColumnWidth: number;
  readonly rowId: string;
}

export function StatusesAsColorBar(props: StatusesAsColorBarProps) {
  const { statusPercentages, statusColumnWidth, rowId } = props;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      {statusPercentages.map(({ status, percentage }) => (
        <Tooltip disableInteractive title={humanCase(status)} key={`${rowId}-${status}`}>
          <Box
            sx={{
              height: 20,
              width: (percentage / 100) * statusColumnWidth,
              backgroundColor: statusColors[status],
            }}
          />
        </Tooltip>
      ))}
    </Box>
  );
}
